module.exports = __webpack_public_path__ + "static/media/icono.hombre.desktop.widget.15bc0077.svg";